import { render, staticRenderFns } from "./PriceRelative.vue?vue&type=template&id=e94f308e&"
import script from "./PriceRelative.vue?vue&type=script&lang=js&"
export * from "./PriceRelative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports